import React, { Component, Fragment } from 'react';
import {
  Row, Col,
  Card, CardBody,
  Spinner
} from 'reactstrap';
import Ionicon from 'react-ionicons';
import cx from 'classnames';

import ModalService from '../../services/ModalService';

// css
import './ProfileDetail.css';

// modal
import RequestDetailUpdateModal from '../../modal/RequestDetailUpdateModal/RequestDetailUpdateModal';
import ChangePassword from '../../modal/ChangePassword/ChangePassword';

class ProfileDetail extends Component {

  state = {
    height: window.innerHeight,
    width: window.innerWidth,
    isRequestDetailModalOpen: false,
    isChangePasswordModalOpen: false
  }

  componentDidMount() {
    window.addEventListener('resize', this.resizeWindow);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeWindow);
  }

  resizeWindow = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }


  openRequestDetailModal = () => {
    this.setState({ isRequestDetailModalOpen: true });
  }

  closeRequestDetailModal = (update) => {
    this.setState({ isRequestDetailModalOpen: false });
    if (update === true) {
      this.props.updateReqButton(update);
    }
  }


  openChangePasswordModal = () => {
    this.setState({ isChangePasswordModalOpen: true });
  }

  closeChangePasswordModal = (update, message) => {
    this.setState({ isChangePasswordModalOpen: false });
    if (update === true) {
      ModalService.openAlert("Update Password", message, 'success');
    }
  }



  render() {
    const { sapId, address, isImageUpdating } = this.props;


    return <div id="profile-detail" className="height-100" style={{ height: 'auto' }}>
      {this.state.isRequestDetailModalOpen && <RequestDetailUpdateModal
        show={this.state.isRequestDetailModalOpen}
        closeModal={this.closeRequestDetailModal} />}

      {this.state.isChangePasswordModalOpen && <ChangePassword
        show={this.state.isChangePasswordModalOpen}
        closeModal={this.closeChangePasswordModal}
      >
      </ChangePassword>}

      <Card id="profile-detail" className="height-100" style={{ height: 'auto' }}>
        <CardBody style={{ paddingBottom: '0px', minHeight: '568px' }}>
          <Row>
            <Col className="text-align-right">
              {(!this.props.fleet_id && <div className="link cursor-pointer" onClick={this.openChangePasswordModal}>Change Password</div>)}
              <br />

              {/* <Ionicon icon="md-create" fontSize="24px" color="#fdbb1f" onClick={this.openRequestDetailModal} /> */}
            </Col>
          </Row>
          <Row>
            <Col className="text-align-center">
              {!this.props.profileImage && <img src="images/Web_Avatar.svg" height="50px" width="auto" className="profile-image" alt="" />}
              {this.props.profileImage && <img src={this.props.profileImage} height="50px" width="auto" className="profile-image" alt="" />}
              {isImageUpdating && <Spinner size="sm" color="primary" className="profile-spinner" />}
              <div className="create-icon-con">
                <label className="profile-image-camera-side">
                  <div className="edit-icon">
                    <Ionicon icon="md-create" fontSize="24px" color="#fff" />
                  </div>
                  {/* <img src="images/profile.svg" alt="profile image" className="profile-upload-image-icon"></img> */}
                  <input type="file" className="visibility-hidden width-0" onChange={this.props.handleUploadImage} />
                </label>
              </div>
            </Col>
          </Row>
          <br />
          <Row>
            <Col className="text-align-center user-name">
              <b className="title-case">{this.props.ownerName}</b>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col>
              <div>Company Name</div>
              <div className="title-case"><b>{this.props.businessName}</b></div>
            </Col>
          </Row>
          <br />
          <Row>
            <Col>
              <div>Member Code</div>
              <div><b>{sapId}</b></div>
            </Col>
          </Row>
          <br />
          <Row className="pb-3">
            <Col>
              <div>Address</div>
              <div className="title-case"><b>{address}</b></div>
            </Col>
          </Row>
          <br />
          {/* <hr /> */}

          {this.props.showRequestButton && <Fragment>
            {this.props.isUpdateProfileRequestSend && <Row
              className={cx(
                'request-send-text-container',
                'padding-bottom-10',
                'text-align-left',
                { 'req-button-container': this.state.width >= 1200 }
              )}
            // className="request-send-text-container text-align-left req-button-container"
            >
              <span><Ionicon icon="ios-alert" fontSize="24px" color="#6e777f" /></span>
              <span className="request-send-text">
                Your request to change details
                  has been recieved. We will review shortly.
              </span>
              {/* <Col xl="1" md="1" sm="1" xs="1">
                <Ionicon icon="ios-alert" fontSize="24px" color="#6e777f" />
              </Col>
              <Col xl="10" md="10" sm="11" xs="11" className="request-send-text">
                Your request to change details
                has been recieved. We will review shortly.
              </Col> */}
            </Row>}
            {!this.props.isUpdateProfileRequestSend && <Row
              className={cx(
                'text-align-left',
                'padding-bottom-10',
                { 'req-button-container': this.state.width >= 1200 }
              )}
            // className={this.state.width < 1200 ? 'text-align-left' : 'text-align-left req-button-container'} 
            >
              {/* <Col className="request-send-text req-button"
                onClick={this.openRequestDetailModal}
              >
                REQUEST TO EDIT
              </Col> */}
            </Row>}
          </Fragment>}
        </CardBody>
      </Card>
    </div >;
  }
}

export default ProfileDetail;
